import $ from "jquery";
import { gsap } from "gsap";

$(function() {

    const winW = $(window).width();

    //lightbox-------------------------------------------
    let _lb, _last_el;
    var lightbox = $('.lightbox');
    closeFn(lightbox);
    $(document).on('click', '.lb_btn', function() {
        _lb = $(this).data('lb');
        _last_el = $(this);
        gsap.to(_lb, { duration: .4, opacity: 1, display: 'flex', ease: 'circ.out' });
        setTimeout(function() {
            lb_acc($(_lb), _last_el);
        }, 500);
    });


    // tab 點選
    $(document).on('keypress', '.lb_btn', function(e) {
        if (e.which == 13) {
            $(this).click();
        }
    });


    function closeFn(lightbox) {
        var lb_close_btn = lightbox.find('.lb_btn_close_link');
        lb_close_btn.click(function(e) {
            {
                gsap.to(lightbox, { duration: .2, opacity: 0, display: 'none', ease: 'circ.out' });
                _last_el.focus();
            }
        });
        lightbox.click(function(e) {
            if ($(e.target).is(lightbox)) {
                gsap.to(lightbox, { duration: .2, opacity: 0, display: 'none', ease: 'circ.out' });
                _last_el.focus();
            }
        });
    }

    function lb_acc(modal, _last_el) {

        var _this_focus = modal.find('.first_focus');
        _this_focus.focus();

        var focusableElementsString = 'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), [tabindex="0"]';
        var focusableElements = modal.find(focusableElementsString);

        focusableElements = Array.prototype.slice.call(focusableElements);

        var firstTabStop = focusableElements[0];
        var lastTabStop = focusableElements[focusableElements.length - 1];

        modal.on('keydown', function(e) {

            // SHIFT + TAB
            if (e.keyCode === 9) {
                if (e.shiftKey) {
                    if (document.activeElement === firstTabStop) {
                        e.preventDefault();
                        $(lastTabStop).focus();
                    }

                    // TAB
                } else {
                    if (document.activeElement === lastTabStop) {
                        e.preventDefault();
                        $(firstTabStop).focus();
                    }
                }
            }

            // ESCAPE
            if (e.keyCode === 27) {
                gsap.to(modal, { duration: .2, opacity: 0, display: 'none', ease: 'circ.out' });
                _last_el.focus();
            }
        });
    }
});